import React from 'react'
import intl from 'react-intl-universal'
import moment from 'moment-timezone'
import { Row, FormGroup, Label, Input, Col } from 'reactstrap'
import { getScheduleStatus, getDocument } from '~/redux/storyData'
import { useSelector } from 'react-redux'
import { EllipsisReduxStore } from '~/types'
interface Props {
  isRequired: boolean
}
export function getPublishDateFromRedux(state: EllipsisReduxStore): string {
  const scheduleStatus = getScheduleStatus(state)
  const document = getDocument(state)
  const isPublished = Boolean(document && document.published_revision_id)
  const isScheduled = Boolean(scheduleStatus && scheduleStatus.publish)

  return isScheduled
    ? scheduleStatus.publish
    : isPublished
    ? document.last_published_at
    : ''
}

const PublishDate = ({ isRequired }: Props) => {
  const timezone =
    useSelector((state: EllipsisReduxStore) => state.settings.timezone) ||
    moment.tz.guess()

  const publishDate = useSelector((state: EllipsisReduxStore) => {
    return getPublishDateFromRedux(state)
  })

  return (
    <Row>
      <Col md="12">
        <FormGroup>
          <Label for="publish_date">
            {intl.get('BasicTemplateConfig.publishDate.label')}
            {isRequired && <span className="text-danger"> ✱</span>}
          </Label>
          <Input
            className="form-control"
            type="text"
            id="publish_date"
            data-testid="publish_date"
            value={
              publishDate
                ? moment(new Date(publishDate)).tz(timezone).format('LLL')
                : ''
            }
            readOnly={true}
            disabled
          />
        </FormGroup>
      </Col>
    </Row>
  )
}

export default PublishDate
